// import React from "react";
// import { FiTarget } from "react-icons/fi"; // Mission icon (clean, premium)

// function MissionSection() {
//   return (
//     <div className="w-full py-20 px-4 md:px-12 bg-primary-color">
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
//         {/* Mission Card */}
//         <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] rounded-3xl p-10 border border-gray-100 relative overflow-hidden">
//           {/* Icon */}
//           <div className="w-14 h-14 rounded-xl bg-primary-color text-secondary-color flex items-center justify-center mb-6 shadow-sm">
//             <FiTarget size={32} />
//           </div>

//           <h2 className="text-3xl font-semibold text-gray-900 mb-4">
//             Our Mission
//           </h2>

//           <p className="text-gray-600 leading-relaxed mb-6">
//             Brandflow's mission is to empower brands entering hyper-competitive
//             cities like Mumbai by building bold identity systems, unforgettable
//             digital presence, and scalable marketing pipelines.
//           </p>

//           <div className="space-y-5 text-gray-700">
//             <div className="flex gap-3">
//               <div className="w-1 bg-primary-color rounded-full"></div>
//               <p>
//                 <span className="font-semibold">Empowering Startups:</span>{" "}
//                 Helping brands enter new cities confidently.
//               </p>
//             </div>

//             <div className="flex gap-3">
//               <div className="w-1 bg-primary-color rounded-full"></div>
//               <p>
//                 <span className="font-semibold">Design-Driven Impact:</span>{" "}
//                 Creating identities that demand attention.
//               </p>
//             </div>

//             <div className="flex gap-3">
//               <div className="w-1 bg-primary-color rounded-full"></div>
//               <p>
//                 <span className="font-semibold">Scalable Digital Systems:</span>{" "}
//                 Marketing + branding aligned for long-term growth.
//               </p>
//             </div>

//             <div className="flex gap-3">
//               <div className="w-1 bg-primary-color rounded-full"></div>
//               <p>
//                 <span className="font-semibold">Cultural Insight:</span> Perfect
//                 positioning for metropolitan audiences.
//               </p>
//             </div>

//             <div className="flex gap-3">
//               <div className="w-1 bg-primary-color rounded-full"></div>
//               <p>
//                 <span className="font-semibold">Startup Ecosystem:</span>{" "}
//                 Collaborative networks for sustainable growth.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Vision Card — unchanged */}
//         <div className="bg-gradient-to-b from-white to-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] rounded-3xl p-10 border border-gray-100 relative overflow-hidden">
//           <div className="w-14 h-14 rounded-xl bg-primary-color text-secondary-color flex items-center justify-center mb-6 shadow-sm">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-9 w-9"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//               />
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//               />
//             </svg>
//           </div>

//           <h2 className="text-3xl font-semibold text-gray-900 mb-4">
//             Our Vision
//           </h2>

//           <p className="text-gray-700 leading-relaxed mb-6">
//             Our vision is to evolve into India’s most trusted brand accelerator,
//             championing brands as they expand across metros through innovation,
//             strategy, and design excellence.
//           </p>

//           <div className="space-y-5 text-gray-800">
//             <div className="flex gap-3">
//               <div className="w-1 bg-primary-color rounded-full"></div>
//               <p>
//                 <span className="font-semibold">Leadership:</span> The go-to
//                 branding & marketing partner in India.
//               </p>
//             </div>
//             <div className="flex gap-3">
//               <div className="w-1 bg-primary-color rounded-full"></div>
//               <p>
//                 <span className="font-semibold">Innovation First:</span> Blend
//                 culture, creativity & technology seamlessly.
//               </p>
//             </div>
//             <div className="flex gap-3">
//               <div className="w-1 bg-primary-color rounded-full"></div>
//               <p>
//                 <span className="font-semibold">Future-Ready Brands:</span>{" "}
//                 Position startups to dominate tomorrow’s markets.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MissionSection;

import React from "react";
import { FiTarget } from "react-icons/fi";

function MissionSection() {
  return (
    <div className="w-full py-20 px-4 md:px-12 bg-primary-color relative overflow-hidden">
      {/* Background glowing orbs for premium feel */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-secondary-color/20 rounded-full blur-[150px]"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-secondary-color/20 rounded-full blur-[150px]"></div>

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 z-10">
        {/* GLASS Mission Card */}
        <div
          className="backdrop-blur-xl bg-white/10 border border-white/20 shadow-[0_8px_40px_rgb(0,0,0,0.25)] 
                        rounded-3xl p-10 relative overflow-hidden 
                        hover:shadow-[0_0_35px_#9b81ff70] transition-all duration-300"
        >
          {/* Icon */}
          <div
            className="w-14 h-14 rounded-xl bg-secondary-color/20 border border-white/30 
                          text-secondary-color flex items-center justify-center mb-6 backdrop-blur-lg shadow-sm"
          >
            <FiTarget size={32} />
          </div>

          <h2 className="text-3xl font-semibold text-white mb-4">
            Our Mission
          </h2>

          <p className="text-white/80 leading-relaxed mb-6">
            Brandflow's mission is to empower brands entering hyper-competitive
            cities like Mumbai by building bold identity systems, unforgettable
            digital presence, and scalable marketing pipelines.
          </p>

          {/* Points */}
          <div className="space-y-5 text-white/90">
            <div className="flex gap-3">
              <div className="w-1 bg-secondary-color rounded-full"></div>
              <p>
                <span className="font-semibold text-white">
                  Empowering Startups:
                </span>{" "}
                Helping brands enter new cities confidently.
              </p>
            </div>

            <div className="flex gap-3">
              <div className="w-1 bg-secondary-color rounded-full"></div>
              <p>
                <span className="font-semibold text-white">
                  Design-Driven Impact:
                </span>{" "}
                Creating identities that demand attention.
              </p>
            </div>

            <div className="flex gap-3">
              <div className="w-1 bg-secondary-color rounded-full"></div>
              <p>
                <span className="font-semibold text-white">
                  Scalable Digital Systems:
                </span>{" "}
                Marketing + branding aligned for long-term growth.
              </p>
            </div>

            <div className="flex gap-3">
              <div className="w-1 bg-secondary-color rounded-full"></div>
              <p>
                <span className="font-semibold text-white">
                  Cultural Insight:
                </span>{" "}
                Perfect positioning for metropolitan audiences.
              </p>
            </div>

            <div className="flex gap-3">
              <div className="w-1 bg-secondary-color rounded-full"></div>
              <p>
                <span className="font-semibold text-white">
                  Startup Ecosystem:
                </span>{" "}
                Collaborative networks for sustainable growth.
              </p>
            </div>
          </div>
        </div>

        {/* GLASS Vision Card */}
        <div
          className="backdrop-blur-xl bg-white/10 border border-white/20 shadow-[0_8px_40px_rgb(0,0,0,0.25)] 
                        rounded-3xl p-10 relative overflow-hidden 
                        hover:shadow-[0_0_35px_#9b81ff70] transition-all duration-300"
        >
          <div
            className="w-14 h-14 rounded-xl bg-secondary-color/20 border border-white/30 
                          text-secondary-color flex items-center justify-center mb-6 backdrop-blur-lg shadow-sm"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-9 w-9"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          </div>

          <h2 className="text-3xl font-semibold text-white mb-4">Our Vision</h2>

          <p className="text-white/80 leading-relaxed mb-6">
            Our vision is to evolve into India’s most trusted brand accelerator,
            championing brands as they expand across metros through innovation,
            strategy, and design excellence.
          </p>

          <div className="space-y-5 text-white/90">
            <div className="flex gap-3">
              <div className="w-1 bg-secondary-color rounded-full"></div>
              <p>
                <span className="font-semibold text-white">Leadership:</span>{" "}
                The go-to branding & marketing partner in India.
              </p>
            </div>

            <div className="flex gap-3">
              <div className="w-1 bg-secondary-color rounded-full"></div>
              <p>
                <span className="font-semibold text-white">
                  Innovation First:
                </span>{" "}
                Blend culture, creativity & technology seamlessly.
              </p>
            </div>

            <div className="flex gap-3">
              <div className="w-1 bg-secondary-color rounded-full"></div>
              <p>
                <span className="font-semibold text-white">
                  Future-Ready Brands:
                </span>{" "}
                Position startups to dominate tomorrow’s markets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MissionSection;
